module.exports = __webpack_public_path__ + "static/media/Tupe2.daedea8c.webp";